<template lang="pug">
div.box
    v-server-table(
        :url="api",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
        template(slot="beforeTable")
            datatable-loader(:name="tableName")
</template>

<script>
import { mapState } from 'vuex';
import formattedCurrencyMixin from '@js/mixins/formatted-currency';

export default {
    mixins: [formattedCurrencyMixin],

    data: function() {
        var that = this;
        return {
            tableName: 'VUETABLE_VARIANT_SALES',
            columns: [
                'code',
                'product',
                'variant',
                'total_quantity',
                'total_net_sales',
            ],
            options: {
                skin: 'table m-b-0 b-b',
                texts: {
                    title: 'Product Sales by Variant',
                    description: 'Shows product sales by variant',
                },
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                headings: {
                    code: 'Barcode',
                    total_net_sales: `Total Net Sales (${this.getCurrency()})`,
                    total_quantity: 'Total Quantity (#)',
                },
                columnsClasses: {
                    total_net_sales: 'text-right',
                    total_quantity: 'text-right',
                },
                pdf_url: Laroute.route(
                    'franchise.report.non_fuel.item.variant.export',
                    {
                        type: 'PDF',
                    },
                ),
                csv_url: Laroute.route(
                    'franchise.report.non_fuel.item.variant.export',
                    {
                        type: 'CSV',
                    },
                ),
                xls_url: Laroute.route(
                    'franchise.report.non_fuel.item.variant.export',
                    {
                        type: 'XLSX',
                    },
                ),
                requestFunction: function(request) {
                    return axios
                        .post(this.url, request)
                        .catch(e => this.dispatch('error', e));
                },
                export_post: true,
                export_filename: 'Product Sales by Variant',
            },
        };
    },

    computed: {
        ...mapState('tillFilter', ['filters']),

        api() {
            return Laroute.route(
                'franchise.report.non_fuel.item.variant.index',
            );
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;

            this.setFilter();
        },

        '$store.getters.currency'(val) {
            this.options.headings.total_net_sales = `Total Net Sales (${this.getCurrency()})`;
        },
    },

    methods: {
        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/variant-sales-report.vue